<template>
  <div class="te-story-container co-container-md te-story-container-bg px-3 py-5 md:p-7">
    <div class="mb-10 flex flex-col sm:mx-60 md:mx-0 md:flex-row md:gap-x-20">
      <!-- プロフィール -->
      <div class="mb-5 text-co-gray-600 md:mb-0">
        <!-- プロフィールの横並び -->
        <div class="mb-3 flex items-center md:items-start">
          <div class="ml-3 mr-4 min-w-[80px] md:ml-0 md:mr-6">
            <img
              src="~/assets/images/Te/TeCommon/Sidejob/Story/profile.svg"
              alt="Kさん"
              width="80"
              height="80"
              loading="lazy"
            >
            <span class="co-display-14 block text-center">
              Kさん
            </span>
          </div>
          <div>
            <p class="te-story-profile-income mb-1">
              テックアカデミーワークス累計収入
            </p>
            <p class="te-story-profile-amount mb-0 font-bold">
              約<span class="te-story-profile-amount-large text-co-primary-500">200,000</span>円
            </p>
            <p class="co-display-14 mb-0 ">
              2022年12月〜2023年9月時点
            </p>
          </div>
        </div>
        <!-- プロフィール下テキスト -->
        <p class="mb-1">
          2022年11月 受講修了、実力判定テスト合格
        </p>
        <p class="mb-1">
          2022年12月 副業を開始
        </p>
        <p class="mb-0">
          現在も継続的に副業を行う
        </p>
      </div>
      <!-- お仕事の一部実績 -->
      <div class="md:w-[62%]">
        <h4 class="te-story-h4 mb-3 font-bold">
          お仕事の一部実績
        </h4>
        <!-- 2並びのテキスト -->
        <div class="te-story-achievement flex items-baseline justify-between pr-1 text-co-gray-600 md:pr-0">
          <p class="te-story-achievement-name mb-0">
            金融系企業<span class="ml-2">ページ制作</span>
          </p>
          <p class="te-story-achievement-reward mb-0">
            報酬<span class="te-story-achievement-amount ml-1 font-bold text-co-primary-400">33,800</span>円
          </p>
        </div>
        <div class="te-story-achievement flex items-baseline justify-between pr-1 text-co-gray-600 md:pr-0">
          <p class="te-story-achievement-name mb-0">
            自動車関連企業<span class="ml-2">LP制作</span>
          </p>
          <p class="te-story-achievement-reward mb-0">
            報酬<span class="te-story-achievement-amount ml-1 font-bold text-co-primary-400">31,020</span>円
          </p>
        </div>
        <div class="te-story-achievement flex items-baseline justify-between pr-1 text-co-gray-600 md:pr-0">
          <p class="te-story-achievement-name mb-0">
            住宅情報サービス<span class="ml-2">ページ制作</span>
          </p>
          <p class="te-story-achievement-reward mb-0">
            報酬<span class="te-story-achievement-amount ml-1 font-bold text-co-primary-400">18,700</span>円
          </p>
        </div>
        <div class="te-story-achievement flex items-baseline justify-between pr-1 text-co-gray-600 md:pr-0">
          <p class="te-story-achievement-name mb-0">
            大手電気メーカー<span class="ml-2">ページ制作</span>
          </p>
          <p class="te-story-achievement-reward mb-0">
            報酬<span class="te-story-achievement-amount ml-1 font-bold text-co-primary-400">33,000</span>円
          </p>
        </div>
        <!-- 注釈 -->
        <span class="te-story-notes co-display-14 text-co-gray-500">
          ※ メンターサポートがついた時の報酬金額（税込）。サポートなしで対応すると報酬額がアップします。
        </span>
      </div>
    </div>
    <!-- 一日のタイムスケジュール例 -->
    <div class="flex flex-col gap-10 sm:mx-60 md:mx-0 md:flex-row md:gap-[4.25rem]">
      <div>
        <h5 class="te-story-h4 mb-3 font-bold md:mb-4">
          一日のタイムスケジュール例
        </h5>
        <p class="mb-0 text-co-gray-600">
          卒業生がテックアカデミーワークスにてどのような時間帯で副業に取り組んでいるかをご紹介。本業と両立が可能であることをご確認いただけます。
        </p>
      </div>
      <div class="flex justify-between gap-5 md:gap-20">
        <div class="text-center">
          <img
            class="mb-2"
            src="~/assets/images/Te/TeCommon/Sidejob/TimeSchedule/graph_weekday.webp"
            alt="平日コツコツタイプ"
            width="171"
            height="229"
            loading="lazy"
          >
          <span class="te-time-schedule-notes text-center text-co-gray-600">就寝前2〜3時間を活用</span>
        </div>
        <div class="text-center">
          <img
            class="mb-2"
            src="~/assets/images/Te/TeCommon/Sidejob/TimeSchedule/graph_holiday.webp"
            alt="休日集中タイプ"
            width="174"
            height="229"
            loading="lazy"
          >
          <span class="te-time-schedule-notes text-center text-co-gray-600">日中空いた時間を活用</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.te-story-container {
  max-width: 60rem;
  background: #e6f7fb;
}

.te-story-profile-income {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
}

.te-story-profile-amount {
  font-size: 1rem;
}

.te-story-profile-amount-large {
  font-size: 1.5rem;
}

.te-story-h4 {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
}

.te-story-achievement {
  @media (max-width: 767.98px) {
    max-width: 26.0625rem;
  }
}

.te-story-achievement-name {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    width: 15rem;
    font-size: 1rem;
  }
}

.te-story-achievement-reward {
  font-size: 0.75rem;
  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
}

.te-story-achievement-amount {
  font-size: 1.125rem;
}

.te-story-notes {
  line-height: 1.5;
  @media (min-width: 768px) {
    line-height: 1.2;
  }
}

.te-time-schedule-notes {
  font-size: 0.75rem;
  white-space: nowrap;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
}
</style>
